module.exports = __webpack_public_path__ + "img/banner_noticias_mobile.192332e8.png";